import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const th = { border: "1px solid #cfd8dc", padding: "6px 8px", fontSize: 11, fontWeight: 700, background: "#eceff1", color: "#37474f", textAlign: "left", whiteSpace: "nowrap" };
const td = { border: "1px solid #e0e0e0", padding: "4px 6px", fontSize: 12, verticalAlign: "middle" };
const inp = { width: "100%", boxSizing: "border-box", border: "1px solid #cfd8dc", padding: "4px 6px", fontSize: 12, borderRadius: 3 };

const CAMPI = [
  { key: "docente", label: "Docente", type: "text", w: 160 },
  { key: "giorno", label: "Giorno", type: "text", w: 120 },
  { key: "ora", label: "Ora", type: "text", w: 90 },
  { key: "piano", label: "Piano", type: "text", w: 70 },
  { key: "interno", label: "Interno tel.", type: "number", w: 90 },
  { key: "uscita", label: "Uscita", type: "text", w: 120 },
];

export default function TabellaCorsiPage() {
  const [anni, setAnni] = useState([]);
  const [anno, setAnno] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savedCode, setSavedCode] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/portineria/corsi-anni");
        const list = r.data?.anni || [];
        setAnni(list);
        setAnno(list[0] || new Date().getFullYear());
      } catch { setAnni([]); }
    })();
  }, []);

  const load = useCallback(async () => {
    if (!anno) return;
    setLoading(true);
    try {
      const r = await api.get("/portineria/corsi", { params: { anno } });
      setRows(r.data?.corsi || []);
    } catch { setRows([]); } finally { setLoading(false); }
  }, [anno]);

  useEffect(() => { load(); }, [load]);

  const setField = (codice, gruppo, key, val) => {
    setRows(rs => rs.map(r => (r.codice === codice && r.gruppo === gruppo) ? { ...r, [key]: val } : r));
  };

  const save = async (row) => {
    try {
      await api.put(`/portineria/corsi/${encodeURIComponent(row.codice)}`, {
        docente: row.docente || "", giorno: row.giorno || "", ora: row.ora || "",
        piano: row.piano || "", interno: row.interno === "" ? null : row.interno,
        uscita: row.uscita || "",
      }, { params: { anno, gruppo: row.gruppo || 1 } });
      const key = `${row.codice}-${row.gruppo}`;
      setSavedCode(key);
      setTimeout(() => setSavedCode(c => c === key ? "" : c), 1500);
    } catch { /* ignore */ }
  };

  return (
    <div data-testid="tabella-corsi" style={{ padding: 12 }}>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 14, marginBottom: 12 }}>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#78909c", textTransform: "uppercase" }}>Anno Scolastico</div>
          <select data-testid="tc-anno" value={anno || ""} onChange={e => setAnno(Number(e.target.value))}
            style={{ padding: "6px 10px", border: "1px solid #ccc", fontSize: 13 }}>
            {anni.map(y => <option key={y} value={y}>{y}/{String((y + 1) % 100).padStart(2, "0")}</option>)}
          </select>
        </div>
        <div style={{ fontSize: 11, color: "#90a4ae", marginBottom: 6 }}>Le modifiche si salvano automaticamente uscendo dal campo.</div>
      </div>

      {loading && <div style={{ padding: 20, color: "#888" }}>Caricamento…</div>}

      {!loading && (
        <div style={{ overflowX: "auto", border: "1px solid #cfd8dc" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }} data-testid="tc-table">
            <thead>
              <tr>
                <th style={{ ...th, minWidth: 90 }}>Codice</th>
                <th style={{ ...th, minWidth: 200 }}>Descrizione</th>
                {CAMPI.map(c => <th key={c.key} style={{ ...th, minWidth: c.w }}>{c.label}</th>)}
                <th style={{ ...th, minWidth: 30 }}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => {
                const rkey = `${row.codice}-${row.gruppo}`;
                return (
                <tr key={rkey} data-testid={`tc-row-${rkey}`}>
                  <td style={{ ...td, fontWeight: 700, whiteSpace: "nowrap" }}>
                    {row.codice}{row.num_gruppi > 1 && <span style={{ marginLeft: 6, background: "#ef6c00", color: "white", fontSize: 9, fontWeight: 800, padding: "1px 5px", borderRadius: 3 }}>G{row.gruppo}</span>}
                  </td>
                  <td style={{ ...td, fontWeight: 600 }}>{row.descrizione}</td>
                  {CAMPI.map(c => (
                    <td key={c.key} style={td}>
                      <input type={c.type} value={row[c.key] ?? ""} data-testid={`tc-${c.key}-${rkey}`}
                        onChange={e => setField(row.codice, row.gruppo, c.key, c.type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
                        onBlur={() => save(row)} style={inp} />
                    </td>
                  ))}
                  <td style={{ ...td, textAlign: "center", color: "#2e7d32", fontWeight: 700 }}>
                    {savedCode === rkey ? "✓" : ""}
                  </td>
                </tr>
                );
              })}
              {rows.length === 0 && (
                <tr><td colSpan={CAMPI.length + 3} style={{ ...td, color: "#888", padding: 20, textAlign: "center" }}>Nessun corso per l&apos;anno selezionato.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
